export default __webpack_public_path__ + "static/redbull-new-e242baa0e9f53b674946bd642c19f840.svg";